module.exports = __webpack_public_path__ + "static/media/chevron-up.b24f2deb.svg";